let settings = {
  ENV: "local",
  EDIT_API_URL: "http://localhost:8081/https://sig-edit-acc.trimm.net",
};

if (window && window.env) {
  settings = {
    ...settings,
    ...window.env,
  };
}

settings.RECAPTCHA_SITE_KEY = "6LcaMTccAAAAAJ7XI2m2xQa-qwEkTP1kJxP_RQiV";

export default settings;
